import { HttpResponse } from "@angular/common/http";
import { Provider } from "@angular/core";
import { Observable } from "rxjs";
import { UseCase } from "../../../core/use-case";
import { ReportEvaluationResourcesByDisciplineFiltersDTO } from "../../models/export-report.model";
import { ProjectEvaluationRepository } from "../../repositories/project-evaluation.repository";

export class ExportResourcesByDisciplineReportUseCase
  implements UseCase<ReportEvaluationResourcesByDisciplineFiltersDTO, HttpResponse<Blob>>
{
  constructor(private repo: ProjectEvaluationRepository) {}
  
  execute(filters: ReportEvaluationResourcesByDisciplineFiltersDTO): Observable<HttpResponse<Blob>> {
    return this.repo.exportResourcesByDisciplineReport(filters);
  }
}

const exportResourcesByDisciplineReportUseCaseFactory = (repo: ProjectEvaluationRepository) =>
  new ExportResourcesByDisciplineReportUseCase(repo);

export const exportResourcesByDisciplineReportUseCaseProvider: Provider = {
  provide: ExportResourcesByDisciplineReportUseCase,
  useFactory: exportResourcesByDisciplineReportUseCaseFactory,
  deps: [ProjectEvaluationRepository],
};
